<!-- nlc-style Coin Widget -->
<div class="nlc-coin-widget nlc-card">
  <!-- Header -->
  <div class="coin-widget-header">
    <div class="widget-icon-wrapper">
      <mat-icon class="widget-icon">paid</mat-icon>
    </div>
    <div class="widget-title-section">
      <h3 class="nlc-heading-4">Deine Coins</h3>
      <p class="nlc-caption">Kontostand und Übersicht</p>
    </div>
  </div>

  <!-- Balance Cards -->
  <div *ngIf="customer$ | async as customer" class="coin-balance-grid">
    <!-- Total Coins -->
    <div class="balance-card balance-total">
      <div class="balance-card-icon total-icon">
        <mat-icon>savings</mat-icon>
      </div>
      <div class="balance-card-content">
        <span class="balance-label">Gesamt</span>
        <span class="balance-amount">{{ customer?.coinsTotal ?? 0 }}</span>
        <span class="balance-caption">Alle Coins</span>
      </div>
    </div>

    <!-- Available Coins -->
    <div class="balance-card balance-available">
      <div class="balance-card-icon available-icon">
        <mat-icon>account_balance_wallet</mat-icon>
      </div>
      <div class="balance-card-content">
        <span class="balance-label">Verfügbar</span>
        <span class="balance-amount">{{ customer?.coinsCurrent || 0 }}</span>
        <span class="balance-caption">Zum Einlösen</span>
      </div>
    </div>
  </div>

  <!-- Earnings Breakdown (Current Year) -->
  <div *ngIf="customer$ | async as customer" class="breakdown-card nlc-card">
    <div class="breakdown-header">
      <mat-icon class="breakdown-icon">insights</mat-icon>
      <span class="breakdown-title">Dieses Jahr verdient</span>
    </div>
    <div class="breakdown-items-grid">
      <div class="breakdown-item">
        <div class="breakdown-item-icon generated-icon">
          <mat-icon>auto_awesome</mat-icon>
        </div>
        <div class="breakdown-item-content">
          <span class="breakdown-item-label">Generiert</span>
          <span class="breakdown-item-value">{{ (generatedCoins$ | async) || 0 }}</span>
          <span class="breakdown-item-caption">Jahresumsatz</span>
        </div>
      </div>
      <div class="breakdown-item">
        <div class="breakdown-item-icon bonus-icon">
          <mat-icon>star</mat-icon>
        </div>
        <div class="breakdown-item-content">
          <span class="breakdown-item-label">Bonus</span>
          <span class="breakdown-item-value">{{ (bonusCoins$ | async) || 0 }}</span>
          <span class="breakdown-item-caption">Staffelungsbonus</span>
        </div>
      </div>
      <div class="breakdown-item">
        <div class="breakdown-item-icon credit-icon">
          <mat-icon>card_giftcard</mat-icon>
        </div>
        <div class="breakdown-item-content">
          <span class="breakdown-item-label">Gutschrift</span>
          <span class="breakdown-item-value">{{ (creditCoins$ | async) || 0 }}</span>
          <span class="breakdown-item-caption">Manuelle Gutschrift</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Error State -->
  <div *ngIf="!(customer$ | async)" class="coin-widget-error">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <span class="error-text">Kontostand konnte nicht geladen werden</span>
  </div>
</div>
